import React, { CSSProperties, ReactNode } from "react";
import Icon from "ui/Icon";
import { SpacingStyle } from "core/styles/paddingMarginStyle";
import { Container, CrossIcon } from "./_chipStyle";

export type ChipProps = {
  color?:
    | "success"
    | "success-2"
    | "danger"
    | "warning"
    | "warning-2"
    | "warning-3"
    | "warning-4"
    | "primary"
    | "secondary"
    | "disabled"
    | "secondary-2"
    | "primitive-3"
    | "neutral"
    | string;
  textColor?: string;
  labelColor?: string;
  icon?: React.ReactNode;
  rounded?: boolean;
  bold?: boolean;
  id?: string | number;
  onClick?: React.MouseEventHandler;
  strokeColor?: string;
  isWrapText?: boolean;
  children?: ReactNode;
  withDeleteButton?: boolean;
  handleDelete?: (event: Event & { target: { id: number } }) => void;
  width?: number | string;
  height?: string;
  size?: number | string;
  fontSize?: number;
  style?: CSSProperties;
  lineHeight?: number | string;
  border?: string;
  className?: string;
} & SpacingStyle;

Chip.defaultProps = {
  color: "default",
  labelColor: "",
  icon: null,
  rounded: false,
  bold: false,
  onClick: null,
  isWrapText: false,
};

function Chip(props: ChipProps) {
  const { icon, withDeleteButton, handleDelete, children, strokeColor, id, ...rest } = props;

  return (
    <Container id={id} {...rest}>
      {icon && <Icon src={icon} size={16} mr={8} />}
      {children}
      {withDeleteButton && <CrossIcon id={id} strokeColor={strokeColor} onClick={handleDelete} />}
    </Container>
  );
}

export default Chip;
